const AVATAR_COLORS = [
  "#2563EB", // blue
  "#16A34A", // green
  "#EA580C", // orange
  "#7C3AED", // purple
  "#0D9488", // teal
  "#DB2777", // pink
  "#64748B", // slate
];

export const getAvatarColor = (seed = "") => {
  let hash = 0;
  for (let i = 0; i < seed.length; i += 1) {
    hash = hash * 31 + seed.charCodeAt(i);
  }
  return AVATAR_COLORS[hash % AVATAR_COLORS.length];
};
